import { render, staticRenderFns } from "./SettingsWorkspaceSlackNotificationForm.vue?vue&type=template&id=06d94339"
import script from "./SettingsWorkspaceSlackNotificationForm.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspaceSlackNotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports